<script lang="ts">export let size = "40px";
export let color = "#FFFFFF";
export let speed = "1s";
</script>

<div
	class="spinner"
	style="
		--spinner-size: {size};
		--spinner-color: {color};
		--spinner-speed: {speed};
	"
/>

<style>
	.spinner {
		display: inline-block;
		border: 4px solid transparent;
		border-radius: 50%;
		border-top-color: var(--spinner-color);
		width: var(--spinner-size);
		height: var(--spinner-size);
		animation: spin var(--spinner-speed) linear infinite;
	}

	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
</style>
